import api from "../../../services/api";

const getUsers = ({ commit }, params = {}) => {
  return new Promise((resolve, reject) => {
    api.get("/report/users", { params }).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_USERS", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getPositionByGrade = ({ commit }, params = {}) => {
  return new Promise((resolve, reject) => {
    api.get("/resume/position", { params }).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_IDSERAGAM", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getGrade = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/grade").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_IDSERAGAM", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getResume = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/report/dashboard").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_IDSERAGAM", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  getPositionByGrade,
  getGrade,
  getResume,
  getUsers
};
